/* Dependencies */
import styled from 'styled-components';

/* Components */
import { Selecter, Button, Checkbox, Texter } from 'lego-dist';

/* Icons */
import { ReactComponent as RoundCheckmark } from 'images/icons/roundCheckmark.svg';
import { ReactComponent as InfoIcon } from 'images/icons/info.svg';

export const StylesAddMemberWrapper = styled.div.attrs(() => ({
  className: 'StylesAddTeacherWrapper',
}))`
  width: 100%;
  height: calc(100vh - 75px);
  overflow-y: auto;

  & form {
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    height: 100%;
  }

  ${({ theme }) => theme.breakPoints.tablet} {
    height: auto;
    overflow-y: visible;
  }
`;

export const GeneralInfoWrapper = styled.div.attrs(() => ({
  className: 'StyledGeneralInfoStepWrapper',
}))`
  width: 100%;
  position: relative;
  form {
    padding: 20px;
  }
`;

export const PermissionsWrapper = styled.div.attrs(() => ({
  className: 'StyledPermissionsStepWrapper',
}))`
  width: 100%;

  > form {
    padding: 20px;
  }

  .legoSelecterOptionsContainer{
    height: 150px;
    overflow: auto;
    padding: 0;

    .legoSelecterOptionHeaderItem {
      font-size: 14px;
    }
    .legoSelecterOptionItem {
      padding: 5px 15px;
      label {
        min-height: 20px;
        padding: 0 5px;
      }
    }
  }
  .StylesAddMemberContent p {
    margin-bottom: 20px;
  }
`;

export const PreviousBtn = styled(Button).attrs(() => ({
  rounded: true,
  small: true,
  fill: true,
  maxWidth: 140,
  color: '#0086D8',
  outline: true,
}))``;

export const Content = styled.div.attrs(() => ({
  className: 'StyledAddTeacherContent',
}))`
  padding-bottom: 4rem;

  color: ${({ theme }) => theme.colors.darkGray};
  font-weight: bold;

  display: flex;
  flex-direction: column;
  justify-content: center;

  .legoSelecterContainer {
    margin-bottom: 10rem;
  }
`;

export const InputGroup = styled.div.attrs(({ className }) => ({
  className: 'StyledAddTeacherInputGroup',
}))`
  display: block;
  margin-bottom: 16px;
  position: relative;

  .legoSelecterOptionIndicator {
    top: 50%;
    transform: translateY(-50%);
  }

  .legoSelecterOptionsList .legoSelecterOptionItem {
    display: flex;
    align-items: center;
  }

`;
export const InputGrid = styled.div.attrs(({ className }) => ({
  className: 'StyledAddTeacherInputInputGrid',
}))`
  display: grid;
  grid-template-columns: repeat(1, 1fr);
  grid-gap: 16px;
  margin-top: 20px;
`;

export const SelectsWrapper = styled.div.attrs(() => ({
  className: 'SelectsWrapper',
}))`
  display: grid;
  grid-template-columns: repeat(1, 1fr);
  grid-gap: 16px;

  ${({ theme }) => `
    ${theme.breakPoints.largeTablet} {
      grid-template-columns: repeat(2, 1fr);
    }
  `}
`;

export const TitleText = styled.p.attrs(() => ({
  className: 'TitleText',
}))`
  font-size: 18px;
  font-weight: 600;
  color: #4A4A4A;
  margin: 0;
  margin-bottom: 5px;
`;

export const DescriptionText = styled.p.attrs(() => ({
  className: 'DescriptionText',
}))`
  font-size: 14px;
  font-weight: 400;
  color: #657480;
  margin: 0;
  margin-bottom: 1rem;
`;

export const Label = styled.label.attrs(() => ({
  className: 'StyledAddTeacherLabel',
}))`
  font-size: 14px;
  font-weight: bold;
  margin-bottom: 6px;

  display: flex;
  align-items: center;
  justify-content: space-between;

  ${({ theme }) => theme.breakPoints.tablet} {
    font-size: 16px;
  }
`;

export const CharCount = styled.div.attrs(() => ({
  className: 'StyledAddTeacherCharCount',
}))`
  color: ${({ theme }) => theme.colors.shadeMedium};
  font-size: 12px;
  font-weight: normal;
`;

export const PermissionTitle = styled.p.attrs(() => ({
  className: 'AddTeacherPermissionTitle',
}))`
  color: #4A4A4A;
  font-size: 18px;
  font-weight: normal;
  margin: 0;
  font-weight: bold;
`;

export const PermissionItem = styled.div.attrs(() => ({
  className: 'AddTeacherDefaultPermissionItem',
}))`
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-bottom: 16px;
`;

export const PermissionItemTitle = styled.h4.attrs(() => ({
  className: 'AddTeacherDefaultPermissionItemTitle',
}))`
  color: #4A4A4A;
  font-size: 16px;
  font-weight: bold;
  line-height: 21px;
  margin: 0;
  margin-bottom: 4px;
`;

export const PermissionText = styled.div.attrs(() => ({
  className: 'AddTeacherDefaultPermissionText',
}))`
  color: ${({ theme }) => theme.colors.shadeDark};
  font-size: 14px;
  font-weight: normal;
  line-height: 18px;
  margin: 0;
  margin-right: 10px;
`;


export const PhotoUploaderContainer = styled.div<any>`
  color: ${({ theme }) => theme.colors.darkGray};
  font-size: 14px;
  font-weight: bold;
  text-align: center;
  margin: 30px auto;

  .legoAvatarPhoto {
    width: 120px;
    height: 120px;
  }
  .legoAvatarSkeleton {
    margin-top: 5px;
    padding: 0;
  }
`;

export const ErrorMessage = styled.div.attrs(() => ({
  className: 'StyledAddTeacherError',
}))`
  color: #ef4b48;
  font-size: 14px;
  font-weight: normal;
  margin-bottom: 20px;
  margin-top: 5px;
`;

export const TextInput = styled(Texter)`
  > input {
    height: 40px;
    width: 100%;

    border: 1px solid ${({ theme }) => theme.colors.shadeMedium};
    border-radius: 8px;
    color: ${({ theme }) => theme.colors.shadeMediumDark} !important;
    font-size: 16px !important;
    font-weight: normal;
    line-height: 16px;
    padding: 0 0 0 12px;

    &:focus {
      border: 1px solid ${({ theme }) => theme.colors.physicalLight30};
    }
  }

  & .texter-error {
    color: #ef4b48;
    font-size: 14px;
    font-weight: normal;
    margin-bottom: 20px;
    margin-top: 5px;
  }
`;

export const BtnWrapper = styled.div.attrs(() => ({
  className: 'StyledAddTeacherButtons',
}))`
  display: flex;
  justify-content: flex-end;
`;

export const NextBtn = styled(Button).attrs(() => ({
  rounded: true,
  small: true,
  fill: true,
  maxWidth: 140,
  color: '#75B753',
  flat: true,
  className: 'StyledAddTeacherNext',
}))`
  width: 120px;
`;

export const Title = styled.div.attrs(() => ({ className: 'AddTeacherTitle' }))`
  font-size: 16px;
  padding: 0;
  margin: 0;
  margin-bottom: 30px;

  ${({ theme }) => theme.breakPoints.tablet} {
    font-size: 18px;
  }
`;

export const Subtitle = styled.div.attrs(() => ({
  className: 'AddTeacherSubtitle',
}))`
  font-size: 16px;
  padding: 0;
  margin: 0 0 5px 0;

  ${({ theme }) => theme.breakPoints.tablet} {
    font-size: 16px;
  }
`;

export const Text = styled.p.attrs(() => ({ className: 'AddTeacherText' }))`
  color: ${({ theme }) => theme.colors.shadeDark};
  font-size: 14px !important;
  font-weight: normal;
  margin-top: 0;
`;

export const PermissionsButtons = styled.div.attrs(() => ({
  className: 'AddTeacherPermissionsButtons ',
}))`
  display: flex;
  align-items: center;
  margin-bottom: 20px;

  & button:first-child {
    border-radius: 4px 0 0 4px;
  }

  & button:last-child {
    border-radius: 0 4px 4px 0;
  }
`;

export const PermissionsBtn = styled.button.attrs(() => ({
  className: 'AddTeacherPermissionsButton',
}))`
  background-color: transparent;
  border: 1px solid #F77B5E;
  color: #F77B5E;
  font-size: 14px;
  height: 35px;
  width: 150px;
`;

export const PermissionsContainer = styled.div.attrs(() => ({
  className: 'AddTeacherPermissionsContainer',
}))`
  overflow-y: scroll;
  padding: 0 16px 16px 0;

  ${({ theme }) => theme.breakPoints.tablet} {
    border-bottom: 1px solid ${({ theme }) => theme.colors.shadeMediumLight};
    height: 240px;
    max-height: 240px;
  }
`;

export const SelectablePermission = styled.div.attrs(() => ({
  className: 'AddTeacherSelectablePermission',
}))`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 24px;
`;

export const StyledCheckbox = styled(Checkbox).attrs(() => ({
  className: 'AddTeacherPermissionsCheckbox',
}))``;

export const OptionerContainer = styled.div.attrs(() => ({
  className: 'AddTeacherOptionerContainer',
}))`
  display: flex;
  gap: 16px;
`;

export const SelectOptionsWrapper = styled.div.attrs(() => ({
  className: 'AddTeacherSelectOptionsWrapper',
}))`
  display: flex;
  flex-direction: column;
  gap: 10px;

  width: 280px;
`;

export const OptionerLabel = styled.label.attrs(() => ({
  className: 'AddTeacherOptionerLabel',
}))`
  display: flex;
  align-items: center;
  gap: 20px;
`;

export const InfoBtn = styled(InfoIcon).attrs(() => ({
  className: 'AddTeacherInfoButton',
}))`
  height: 24px;
  width: 24px;

  & svg {
    object-fit: cover;
  }

  & #Oval {
    stroke: ${({ theme }) => theme.colors.shadeMedium};
  }

  & #i {
    fill: ${({ theme }) => theme.colors.shadeMedium};
  }
`;

interface FooterProps {
  alignRight?: boolean;
}

export const Footer = styled.div.attrs(() => ({
  className: 'StyledAddTeacherFooter',
}))<FooterProps>`
  position: absolute;
  bottom: 0;
  right: 0;
  display: flex;
  align-items: center;
  ${({ alignRight = false }) => `
      ${alignRight ? `
        justify-content: flex-end;
      ` : `
        justify-content: space-between;
      `}
  `}
  box-sizing: border-box;
  width: 100%;
  border-top: 1px solid #dde4ea;
  padding: 20px;
`;

export const Illustration = styled(RoundCheckmark).attrs(() => ({
  className: 'AddTeacherSuccessIllustration',
}))`
  height: 60px;
  width: 60px;
  margin-bottom: 30px;

  & #fill {
    fill: #75b753;
  }

  & #checkmark {
    fill: ${({ theme }) => theme.colors.white};
  }
`;

export const Wrapper = styled.div.attrs(() => ({
  className: 'AddTeacherWrapper',
}))`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  padding: 60px 16px;
`;

export const Caption = styled.div.attrs(() => ({
  className: 'AddTeacherCaption',
}))`
  color: ${({ theme }) => theme.colors.darkGray};
  font-size: 16px;
  font-weight: bold;

  ${({ theme }) => theme.breakPoints.tablet} {
    font-size: 20px;
  }
`;


export const Select = styled(Selecter).attrs(() => ({
  className: 'CustomSelecter',
}))``;
